itsoftApp.createModule("accordion", ["windowResize"], function() {
    var module = this;

    var initAccordions = function (accordion) {
        var accordionInitialized = false;
        var accordionDestroyWidth = accordion.getAttribute("data-destroy-accordion");
        var accordionHeadElements = accordion.querySelectorAll(".js-accordion-head");

        var init = function () {
            Array.prototype.forEach.call(accordionHeadElements, function (el) {
                el.addEventListener("click", function (evt) {
                    evt.preventDefault();

                    var self = this;
                    var activeHead;
                    var currentHead;

                    // стили находятся в файле assets/styles/page.styl

                    var closeAccordion = function (el) {
                        if (self.classList.contains("js-accordion-head--parent")) {
                            // находим родителя активного элемента
                            var parent = el;
                            var accordionItem = el.closest(".js-accordion-item");
                            var nextElement = parent.parentNode.querySelector(".js-accordion-content");
                            // добавляем класс для анимации отображения/скрытия
                            parent.classList.add("js-accordion-parent--ready");
                            var height = nextElement.clientHeight + "px";
                            nextElement.style.height = height;

                            var onTransitionEnd = function () {
                                // удаляем у активного элемента активный класс
                                activeHead.classList.remove("js-accordion-head--active");
                                accordionItem.classList.remove("js-accordion-item--active");
                                // у родителя тоже
                                parent.classList.remove("js-accordion-parent--active");
                                parent.classList.remove("js-accordion-parent--ready");
                                nextElement.removeEventListener("transitionend", onTransitionEnd);
                            }

                            nextElement.addEventListener("transitionend", onTransitionEnd);

                            requestAnimationFrame(function () {
                                requestAnimationFrame(function () {
                                    // добавляем для соседнего элемента с контентом нулевую высоту
                                    nextElement.style.height = "0px";
                                })
                            });
                        } else {
                            var nextElement = activeHead.parentNode.querySelector(".js-accordion-content");
                            var accordionItem = activeHead.closest(".js-accordion-item");
                            activeHead.classList.add("js-accordion-head--ready");
                            accordionItem.classList.remove("js-accordion-open");
                            accordionItem.classList.add("js-accordion-close");
                            var height = nextElement.clientHeight + "px";
                            nextElement.style.height = height;

                            var onTransitionEnd = function () {
                                accordionItem.classList.remove("js-accordion-item--active");
                                activeHead.classList.remove("js-accordion-head--ready");
                                activeHead.classList.remove("js-accordion-head--active");
                                accordionItem.classList.remove("js-accordion-close");
                                nextElement.removeEventListener("transitionend", onTransitionEnd);
                            };

                            nextElement.addEventListener("transitionend", onTransitionEnd);

                            requestAnimationFrame(function () {
                                requestAnimationFrame(function () {
                                    nextElement.style.height = "0px";
                                });
                            });
                        }
                    }

                    var openAccordion = function (el) {
                        if (self.classList.contains("js-accordion-head--parent")) {
                            var parent = el;
                            var accordionItem = el.closest(".js-accordion-item");
                            var nextElement = el.parentNode.querySelector(".js-accordion-content");
                            currentHead.classList.add("js-accordion-head--active");
                            parent.classList.add("js-accordion-parent--active");
                            accordionItem.classList.add("js-accordion-item--active");
                            nextElement.style.height = "auto";
                            var height = nextElement.clientHeight + "px";
                            nextElement.style.height = "0px";
                            requestAnimationFrame(function () {
                                requestAnimationFrame(function () {
                                    nextElement.style.height = height;
                                });
                            });
                        } else {
                            var nextElement = currentHead.parentNode.querySelector(".js-accordion-content");
                            var accordionItem = currentHead.closest(".js-accordion-item");
                            currentHead.classList.add("js-accordion-head--active");
                            accordionItem.classList.add("js-accordion-item--active");
                            nextElement.style.height = "auto";
                            var height = nextElement.clientHeight + "px";
                            nextElement.style.height = "0px";
                            var onTransitionEnd = function () {
                                accordionItem.classList.add("js-accordion-open");
                                nextElement.removeEventListener("transitionend", onTransitionEnd);
                                // requestAnimationFrame(function () {

                                // });
                            }
                            nextElement.addEventListener("transitionend", onTransitionEnd);
                            requestAnimationFrame(function () {
                                requestAnimationFrame(function () {
                                    nextElement.style.height = height;
                                });
                            });
                        }
                    }

                    // Если элемент, на котором произошло событие, имеет класс js-accordion-head--parent
                    if (this.classList.contains("js-accordion-head--parent")) {
                        // Если этот элемент был уже активен
                        if (this.classList.contains("js-accordion-head--active")) {
                            activeHead = self;
                            var activeParent = activeHead.closest(".js-accordion-parent");
                            closeAccordion(activeParent);
                            accordion.classList.remove("js-accordion--active");
                        } else {
                            activeHead = accordion.querySelector(".js-accordion .js-accordion-head--active");

                            if (activeHead) {
                                var activeParent = activeHead.closest(".js-accordion-parent");
                                closeAccordion(activeParent);
                            }
                            currentHead = self;

                            var currentParent = currentHead.closest(".js-accordion-parent");
                            openAccordion(currentParent);
                            accordion.classList.add("js-accordion--active");
                            // if (activeHead) {
                            //     setTimeout(function () {
                            //         itsoftApp.modules.animateScroll.callback(currentHead);
                            //     }, 500);
                            // }
                        }
                    } else {
                        // Если этот элемент был уже активен
                        if (this.classList.contains("js-accordion-head--active")) {
                            activeHead = self;
                            var parentContent = activeHead.closest(".js-accordion-content");

                            if (parentContent) {
                                parentContent.style = "";
                            }
                            closeAccordion();
                            accordion.classList.remove("js-accordion--active");
                        } else {
                            currentHead = self;

                            if (!accordion.classList.contains("js-accordion-multi")) {

                                activeHead = accordion.querySelector(".js-accordion .js-accordion-head--active:not(.js-accordion-head--child)");

                                if (activeHead && !currentHead.classList.contains("js-accordion-head--child")) {
                                    closeAccordion();
                                }

                                var parentContent = currentHead.closest(".js-accordion-content");

                                if (parentContent) {
                                    parentContent.style = "";
                                }
                            }

                            openAccordion();
                            accordion.classList.add("js-accordion--active");
                            // if (activeHead) {
                            //     setTimeout(function () {
                            //         itsoftApp.modules.animateScroll.callback(currentHead);
                            //     }, 500);
                            // }
                        }
                    }
                });
            });
        }

        if (accordionDestroyWidth) {
            if (itsoftApp.utils.getViewportSize() >= +accordionDestroyWidth) {
                itsoftApp.modules.windowResize.addEvent(function () {
                    if ((itsoftApp.utils.getViewportSize() < +accordionDestroyWidth) && !accordionInitialized) {
                        accordionInitialized = true;
                        init();
                    }
                });
                return;
            } else {
                accordionInitialized = true;
                init();
            }
        } else {
            init();
        }
    }

    module.callback = initAccordions;
});